import { useCallback, useRef, useState } from 'react';

import { Slideshow } from 'components/Slideshow';
import { useModalContainerFunctions } from 'containers/ShowModalContainer';
import { CmsApiImageGalleryBlockData } from 'modules/cms/api/types/CmsApiImageGallery';
import { useElementReachedEffect } from 'utils/screen';

type Props = {
  data: CmsApiImageGalleryBlockData;
  blockIndex: number;
};

export function CmsImageGalleryBlock({ data: { images }, blockIndex }: Props) {
  const [show, setShow] = useState(blockIndex > 2);
  const lazyRef = useRef<HTMLDivElement>(null);

  useElementReachedEffect({
    ref: lazyRef,
    offset: { top: 200 },
    onReach: useCallback(() => setShow(true), []),
  });

  const { showModal } = useModalContainerFunctions();
  const openMediaGallery = useCallback(
    ({ itemIndex }: { itemIndex: number }) => {
      // @ts-expect-error TS(2322): Type 'SlideshowData[]' is not assignable to type '... Remove this comment to see the full error message
      showModal('MEDIA_GALLERY', { items: images, itemIndex });
    },
    [images, showModal]
  );

  if (!show) return <div ref={lazyRef} />;

  return (
    <Slideshow
      carouselId={`cms-image-gallery-carousel-${blockIndex}`}
      items={images}
      data-qa-id="cms-image-gallery"
      round
      onClickIndex={openMediaGallery}
    />
  );
}
